export const useSystemBarStore = defineStore('systemBar', () => {
  const systemMsgText = ref<string | null>(null)

  const snackbar = ref<boolean>(true)
  const snackbarText = ref<string | null>(null)
  const snackbarTimeout = ref<number>(1000)

  function setSnackbar(text: string, timeout: number = snackbarTimeout.value) {
    snackbar.value = true
    snackbarText.value = text
    snackbarTimeout.value = timeout

    systemMsgText.value = text
  }

  return { systemMsgText, snackbar, snackbarText, snackbarTimeout, setSnackbar }
})
